import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fcb05ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "amount-item" }
const _hoisted_3 = { style: {"width":"135px"} }
const _hoisted_4 = { class: "amount-item" }
const _hoisted_5 = { style: {"width":"120px"} }
const _hoisted_6 = { class: "amount-item" }
const _hoisted_7 = { style: {"width":"145px"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Download Sample Check Form")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Log")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileTextOutlined = _resolveComponent("FileTextOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_FileSearchOutlined = _resolveComponent("FileSearchOutlined")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_table_wrapper = _resolveComponent("table-wrapper")!
  const _component_log_modal = _resolveComponent("log-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_table_wrapper, {
      "is-pagination": _ctx.isPagination,
      "bottom-height": 30,
      class: "table-wrapper"
    }, {
      default: _withCtx((slotProps) => [
        _createVNode(_component_a_table, {
          scroll: { y: slotProps.tableHeight, x: 1400 },
          dataSource: _ctx.data,
          columns: _ctx.column,
          rowKey: "id",
          pagination: false,
          rowSelection: _ctx.tableSelection,
          rowClassName: _ctx.getRowClass
        }, {
          packageCode: _withCtx(({ record }) => [
            _createElementVNode("span", {
              class: "link",
              onClick: ($event: any) => (_ctx.handleGoTo(record))
            }, _toDisplayString(record.packageCode), 9, _hoisted_1)
          ]),
          submitProgramNo: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(record.submitProgramNo), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.toThousandsAndTwoDecimal(record.submitProgramNoAmount)), 1)
            ])
          ]),
          spotCheckedNo: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(record.spotCheckedNo), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.toThousandsAndTwoDecimal(record.spotCheckedNoAmount)), 1)
            ])
          ]),
          controllingCheckedNo: _withCtx(({ record }) => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(record.controllingCheckedNo), 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.toThousandsAndTwoDecimal(record.controllingCheckedNoAmount)), 1)
            ])
          ]),
          operation: _withCtx(({ record }) => [
            _createVNode(_component_a_tooltip, null, {
              title: _withCtx(() => [
                _hoisted_8
              ]),
              default: _withCtx(() => [
                _createVNode(_component_FileTextOutlined, {
                  onClick: ($event: any) => (_ctx.handleExportSampleCheckForm(record)),
                  class: "link btn"
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          log: _withCtx(({ record }) => [
            (_ctx.$btnPermissions('ACR-PT04', '/spotCheckingControlling'))
              ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
                  title: _withCtx(() => [
                    _hoisted_9
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_FileSearchOutlined, {
                      onClick: ($event: any) => (_ctx.handleLog(record)),
                      class: "link btn"
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["scroll", "dataSource", "columns", "rowSelection", "rowClassName"])
      ]),
      _: 1
    }, 8, ["is-pagination"]),
    _createVNode(_component_log_modal, {
      visible: _ctx.logModalVisible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.logModalVisible) = $event)),
      "log-data": _ctx.logData
    }, null, 8, ["visible", "log-data"])
  ], 64))
}